// extracted by mini-css-extract-plugin
export var bodySections = "_b3-8";
export var gray = "_b3-7";
export var green = "_b3-4";
export var iconContainer = "_b3-9";
export var iconWidgetContainer = "_b3-1";
export var phoneIcon = "_b3-2";
export var red = "_b3-5";
export var statusDot = "_b3-3";
export var widgetContainer = "_b3-0";
export var yellow = "_b3-6";